import "./ConfigPanel.css";


// import { loadConfig, saveConfig } from "../utils/configio";


import { Button, Checkbox, Layout, Menu, Modal, Radio, Form, Col, Row, Input, InputNumber, Space } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";

function ResizePopupPanel({ open, setOpen, data }) {

    const [panelOpen, setPanelOpen] = useState(false)
    const [canceled, setCanceled] = useState(false)

    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [location, setLocation] = useState(5)
    // const [value, setLocation] = useState(5);

    useEffect(() => {
        if (data) {
            setWidth(data[0]);
            setHeight(data[1]);
        }
    }, [data])


    const handleOk = () => {
        // console.log("ooo", "handleConfirm");
        setOpen(false);
        let ok = window.PSMan?.getInstance().resize(width, height, location);
        // saveConfig(cfg, () => {console.log("++++++++++++++++");});
    }

    const handleCancel = () => {
        setCanceled(true)
        setPanelOpen(false)
        setTimeout(() => {
            setOpen(false)
        }, 0)
    }

    const [disabled, setDisabled] = useState(true);
    
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setLocation(e.target.value);
    };


    return (
        <Modal
            // maskStyle={{ background: "none" }}
            centered
            open={open}
            width={600}
            onOk={handleOk}
            onCancel={handleCancel}
            // footer={null}
            // closeIcon={<span className="hidden-close"></span>}
            // className="no-padding-modal"
            // maskClosable={false}
            // okButtonProps={{
            //     disabled: true,
            // }}
            // cancelButtonProps={{
            //     disabled: true,
            // }}
            title={
                <div
                    style={{
                        width: "100%",
                        fontSize: "13pt",
                        // cursor: "move",
                        textAlign: "center",
                        // background: "#424242",
                        padding: 0,
                        // borderRadius: "8px 8px 0 0",
                    }}
                    onMouseOver={() => {
                        if (disabled) {
                            setDisabled(false);
                        }
                    }}
                    onMouseOut={() => {
                        setDisabled(true);
                    }}
                    onFocus={() => { }}
                    onBlur={() => { }}
                >
                    设置
                </div>
            }
        // title={"设置"}
        // afterOpenChange={handleOpenChange}
        // modalRender={(modal) => (
        //     <Draggable
        //         disabled={disabled}
        //         bounds={bounds}
        //         nodeRef={draggleRef}
        //         onStart={(event, uiData) => onStart(event, uiData)}
        //     >
        //         <div ref={draggleRef}>{modal}</div>
        //     </Draggable>
        // )}
        >

            <Form size="small" labelCol={{ span: 2 }} labelAlign="left">

                <Form.Item label="宽高:">
                    <Space>
                    <InputNumber min={128} max={8192} value={width} onChange={(v) => setWidth(v)}></InputNumber>
                    <span>X</span>
                    <InputNumber min={128} max={8192} value={height} onChange={(v) => setHeight(v)}></InputNumber>
                    </Space>
                </Form.Item>

                <Form.Item label="定位:">
                    <Radio.Group onChange={onChange} value={location}>
                        <Row align="middle" >
                            <Radio value={1}></Radio>
                            <Radio value={2}></Radio>
                            <Radio value={3}></Radio>
                        </Row>
                        <Row align="middle" >

                            <Radio value={4}></Radio>
                            <Radio value={5}></Radio>
                            <Radio value={6}></Radio>
                        </Row>
                        <Row align="middle" >
                            <Radio value={7}></Radio>
                            <Radio value={8}></Radio>
                            <Radio value={9}></Radio>
                        </Row>


                    </Radio.Group>

                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ResizePopupPanel;
